/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 */

import { types, applySnapshot, getSnapshot } from 'mobx-state-tree';
import { toJS } from 'mobx';
import Framework from '@greenville/framework';
import * as constants from '../../constants/AgenticServiceConstants';

const AgenticGraphListModel = types
  .model('AgenticGraphListModel', {
    graphs: types.optional(types.array(types.frozen()), []),
    error: types.maybeNull(types.string)
  })
  .views((self) => ({
    get graphListData() {
      return {
        graphs: toJS(self.graphs),
        error: self.error
      };
    }
  }))
  .actions((self) => ({
    getGraphs(payload) {
      applySnapshot(self.graphs, []);
      Framework.getEventManager().publish(constants.GET_AGENTIC_GRAPHS, { payload });
    },

    setGraphs(data) {
      applySnapshot(self.graphs, data?.graphs || []);
      Framework.getEventManager().publish(constants.GET_AGENTIC_GRAPHS_SUCCESS, { graphs: data?.graphs || [] });
    },

    setError(errorMessage) {
      applySnapshot(self, {
        ...getSnapshot(self),
        error: errorMessage
      });
      Framework.getEventManager().publish(constants.GET_AGENTIC_GRAPHS_ERROR, { error: errorMessage });
    },

    resetState() {
      applySnapshot(self, {
        ...getSnapshot(self),
        graphs: [],
        error: null
      });
    }
  }));

export default AgenticGraphListModel;
